var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",on:{"click":_vm.to}},[_c('img',{attrs:{"src":"https://s6.bihukankan.com/img/1694487186Group 4373.svg","alt":""}}),_c('span',[_vm._v(_vm._s(_vm.searchName))])])}
var staticRenderFns = []

export { render, staticRenderFns }